import { PageFilter } from '../state/app';
import {
  SampleDevelopmentNlApprovalRequest,
  SampleDevelopmentNlApprovalRequestListFilter,
} from '../state/sampleDevelopmentNlApprovalRequest/sampleDevelopmentNlApprovalRequest.types';
import axios from '../utils/axios';
const baseUrl = `/api/sampleDevelopmentNlApprovalRequests`;

export const fetchSampleDevelopmentNlApprovalRequestList = async ({
  filters,
  paging,
}: {
  filters: SampleDevelopmentNlApprovalRequestListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const updateSampleDevelopmentNlApprovalRequesResponse = async (
  sampleDevelopmentNlApprovalRequest: SampleDevelopmentNlApprovalRequest,
) => {
  const requestUrl = `${baseUrl}/response`;
  return await axios.put(requestUrl, sampleDevelopmentNlApprovalRequest);
};
